import React, { Component } from 'react';
import Members from './components/members/members';
import Customers from './components/customers/customers';
import Order from './components/order/order';
import Axios from 'axios';
import { Container, Button, Table, TableCell } from 'semantic-ui-react';
import './index.css';

class App extends Component {

  constructor(props) {
    super(props);
    this.selectedMemberChange = this.selectedMemberChange.bind(this);
    this.selectedCustomerChange = this.selectedCustomerChange.bind(this);
    this.orderChange = this.orderChange.bind(this);
    this.placeOrder = this.placeOrder.bind(this);
    this.loadOverview = this.loadOverview.bind(this);
    this.showOverview = this.showOverview.bind(this);
    this.calcTotalPrice = this.calcTotalPrice.bind(this);
    this.calcTotelQty = this.calcTotelQty.bind(this);
    this.state = {
      selectedMember: {},
      selectedCustomer: {},
      order: {},
      showOverview: false,
      sales2018: [],
      sales2019: [],
      sales2020: [],
      sales2021: [],
      sales2022: [],
      sales2023: []
    };
  }


  selectedMemberChange(member) {
    this.setState({
      selectedMember: member
    });
  }

  selectedCustomerChange(customer) {
    this.setState({
      selectedCustomer: customer
    });
  }

  orderChange(order) {
    this.setState({
      order: order
    });
  }

  showOverview() {
    this.loadOverview();
  }

  loadOverview() {
    Axios.get('http://165.227.166.190/orders/sales/' + this.state.selectedMember.id).then(res => {
      console.log(res.data);
      this.setState({
        sales2018: res.data["year2018"] ? res.data["year2018"] : [],
        sales2019: res.data["year2019"] ? res.data["year2019"] : [],
        sales2020: res.data["year2020"] ? res.data["year2020"] : [],
        sales2021: res.data["year2021"] ? res.data["year2021"] : [],
	sales2022: res.data["year2022"] ? res.data["year2022"] : [],
	sales2023: res.data["year2023"] ? res.data["year2023"] : [],
  	sales2024: res.data["year2024"] ? res.data["year2024"] : [],
        sales2025: res.data["year2025"] ? res.data["year2025"] : [],
	showOverview: true
      });
    });
  }

  placeOrder() {

    if (this.state.selectedCustomer.email === "") {
      alert('vul het email adres van de klant in aub.');
    }
    else {
      Axios.post('http://165.227.166.190/orders', this.state.order).then((res) => {
        alert('Het order is geplaatst!');
        this.setState({
          selectedMember: {},
          selectedCustomer: {},
          order: {}
        });
        window.location.reload();
      }).catch(res => {
        console.log(res);
      });
    }

  }
  calcTotelQty(key) {
    let qty = 0;
    this.state[key].forEach(row => {
      qty = qty + row.hoeveelheid;
    })
    return qty;
  }
  calcTotalPrice(key) {
    let price = 0;
    this.state[key].forEach(row => {
      price = price + parseInt(row.totaal, 10);
    })
    return price;
  }

  reload() {
    window.location.reload();
  }

  render() {
    return (
      <Container>
        {
          this.state.showOverview ? (
            <div>
              <Button styles={{ marginTop: "20px", marginBottom: "20px" }} onClick={this.reload}>Terug</Button>

              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Order</Table.HeaderCell>
                    <Table.HeaderCell>Bedrijf</Table.HeaderCell>
                    <Table.HeaderCell>Contactpersoon</Table.HeaderCell>
                    <Table.HeaderCell>Email</Table.HeaderCell>
                    <Table.HeaderCell>Product</Table.HeaderCell>
                    <Table.HeaderCell>Aantal</Table.HeaderCell>
                    <Table.HeaderCell>Prijs</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
		<Table.Body>






		  <Table.Row>
                    <TableCell className="tableYearFormat">2025</TableCell>
                  </Table.Row>
                  {
                    this.state.sales2025.map(row => {
                      return (
                        <Table.Row>
                          <Table.Cell>{row.orderNummer}</Table.Cell>
                          <Table.Cell>{row.bedrijf}</Table.Cell>
                          <Table.Cell>{row.contactpersoon}</Table.Cell>
                          <Table.Cell>{row.contactemail}</Table.Cell>
                          <Table.Cell>{row.product}</Table.Cell>
                          <Table.Cell>{row.hoeveelheid}</Table.Cell>
                          <Table.Cell>€ {row.totaal}</Table.Cell>
                        </Table.Row>
                      )

                    })
                  }
		<Table.Row>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell><strong>Totaal</strong></Table.Cell>
		    <Table.Cell>{this.calcTotelQty("sales2025")}</Table.Cell>
                    <Table.Cell>€ {this.calcTotalPrice("sales2025")}</Table.Cell>
                  </Table.Row>






		<Table.Row>
                    <TableCell className="tableYearFormat">2024</TableCell>
                  </Table.Row>
                  {
                    this.state.sales2024.map(row => {
                      return (
                        <Table.Row>
                          <Table.Cell>{row.orderNummer}</Table.Cell>
                          <Table.Cell>{row.bedrijf}</Table.Cell>
                          <Table.Cell>{row.contactpersoon}</Table.Cell>
                          <Table.Cell>{row.contactemail}</Table.Cell>
                          <Table.Cell>{row.product}</Table.Cell>
                          <Table.Cell>{row.hoeveelheid}</Table.Cell>
                          <Table.Cell>€ {row.totaal}</Table.Cell>
                        </Table.Row>
                      )

                    })
                  }
                <Table.Row>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell><strong>Totaal</strong></Table.Cell>
		    <Table.Cell>{this.calcTotelQty("sales2024")}</Table.Cell>
                    <Table.Cell>€ {this.calcTotalPrice("sales2024")}</Table.Cell>
                  </Table.Row>



		<Table.Row>
                    <TableCell className="tableYearFormat">2023</TableCell>
                  </Table.Row>
                  {
                    this.state.sales2023.map(row => {
                      return (
                        <Table.Row>
                          <Table.Cell>{row.orderNummer}</Table.Cell>
                          <Table.Cell>{row.bedrijf}</Table.Cell>
                          <Table.Cell>{row.contactpersoon}</Table.Cell>
                          <Table.Cell>{row.contactemail}</Table.Cell>
                          <Table.Cell>{row.product}</Table.Cell>
                          <Table.Cell>{row.hoeveelheid}</Table.Cell>
                          <Table.Cell>€ {row.totaal}</Table.Cell>
                        </Table.Row>
                      )

                    })
                  }
                  <Table.Row>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell><strong>Totaal</strong></Table.Cell>
                    <Table.Cell>{this.calcTotelQty("sales2022")}</Table.Cell>
                    <Table.Cell>€ {this.calcTotalPrice("sales2023")}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <TableCell className="tableYearFormat">2022</TableCell>
                  </Table.Row>
                  {
                    this.state.sales2022.map(row => {
                      return (
                        <Table.Row>
                          <Table.Cell>{row.orderNummer}</Table.Cell>
                          <Table.Cell>{row.bedrijf}</Table.Cell>
                          <Table.Cell>{row.contactpersoon}</Table.Cell>
                          <Table.Cell>{row.contactemail}</Table.Cell>
                          <Table.Cell>{row.product}</Table.Cell>
                          <Table.Cell>{row.hoeveelheid}</Table.Cell>
                          <Table.Cell>€ {row.totaal}</Table.Cell>
                        </Table.Row>
                      )

                    })
                  }
                  <Table.Row>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell><strong>Totaal</strong></Table.Cell>
                    <Table.Cell>{this.calcTotelQty("sales2022")}</Table.Cell>
                    <Table.Cell>€ {this.calcTotalPrice("sales2022")}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <TableCell className="tableYearFormat">2021</TableCell>
                  </Table.Row>
                  {
                    this.state.sales2021.map(row => {
                      return (
                        <Table.Row>
                          <Table.Cell>{row.orderNummer}</Table.Cell>
                          <Table.Cell>{row.bedrijf}</Table.Cell>
                          <Table.Cell>{row.contactpersoon}</Table.Cell>
                          <Table.Cell>{row.contactemail}</Table.Cell>
                          <Table.Cell>{row.product}</Table.Cell>
                          <Table.Cell>{row.hoeveelheid}</Table.Cell>
                          <Table.Cell>€ {row.totaal}</Table.Cell>
                        </Table.Row>
                      )

                    })
                  }
                  <Table.Row>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell><strong>Totaal</strong></Table.Cell>
                    <Table.Cell>{this.calcTotelQty("sales2021")}</Table.Cell>
                    <Table.Cell>€ {this.calcTotalPrice("sales2021")}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <TableCell className="tableYearFormat">2020</TableCell>
                  </Table.Row>
                  {
                    this.state.sales2020.map(row => {
                      return (
                        <Table.Row>
                          <Table.Cell>{row.orderNummer}</Table.Cell>
                          <Table.Cell>{row.bedrijf}</Table.Cell>
                          <Table.Cell>{row.contactpersoon}</Table.Cell>
                          <Table.Cell>{row.contactemail}</Table.Cell>
                          <Table.Cell>{row.product}</Table.Cell>
                          <Table.Cell>{row.hoeveelheid}</Table.Cell>
                          <Table.Cell>€ {row.totaal}</Table.Cell>
                        </Table.Row>
                      )

                    })
                  }
                  <Table.Row>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell><strong>Totaal</strong></Table.Cell>
                    <Table.Cell>{this.calcTotelQty("sales2020")}</Table.Cell>
                    <Table.Cell>€ {this.calcTotalPrice("sales2020")}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <TableCell className="tableYearFormat">2019</TableCell>
                  </Table.Row>
                  {
                    this.state.sales2019.map(row => {
                      return (
                        <Table.Row>
                          <Table.Cell>{row.orderNummer}</Table.Cell>
                          <Table.Cell>{row.bedrijf}</Table.Cell>
                          <Table.Cell>{row.contactpersoon}</Table.Cell>
                          <Table.Cell>{row.contactemail}</Table.Cell>
                          <Table.Cell>{row.product}</Table.Cell>
                          <Table.Cell>{row.hoeveelheid}</Table.Cell>
                          <Table.Cell>€ {row.totaal}</Table.Cell>
                        </Table.Row>
                      )

                    })
                  }
                  <Table.Row>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell><strong>Totaal</strong></Table.Cell>
                    <Table.Cell>{this.calcTotelQty("sales2019")}</Table.Cell>
                    <Table.Cell>€ {this.calcTotalPrice("sales2019")}</Table.Cell>
                  </Table.Row>

                  <Table.Row>
                    <TableCell className="tableYearFormat">2018</TableCell>
                  </Table.Row>
                  {
                    this.state.sales2018.map(row => {
                      return (
                        <Table.Row>
                          <Table.Cell>{row.orderNummer}</Table.Cell>
                          <Table.Cell>{row.bedrijf}</Table.Cell>
                          <Table.Cell>{row.contactpersoon}</Table.Cell>
                          <Table.Cell>{row.contactemail}</Table.Cell>
                          <Table.Cell>{row.product}</Table.Cell>
                          <Table.Cell>{row.hoeveelheid}</Table.Cell>
                          <Table.Cell>€ {row.totaal}</Table.Cell>
                        </Table.Row>
                      )

                    })
                  }
                  <Table.Row>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell></Table.Cell>
                    <Table.Cell><strong>Totaal</strong></Table.Cell>
                    <Table.Cell>{this.calcTotelQty("sales2018")}</Table.Cell>
                    <Table.Cell>€ {this.calcTotalPrice("sales2018")}</Table.Cell>
                  </Table.Row>

                </Table.Body>
                <Table.Footer>

                </Table.Footer>
              </Table>


            </div>

          ) : (
            <div>
              <Members onChange={this.selectedMemberChange} salesDetailsClicked={this.showOverview} />
              <Customers member={this.state.selectedMember} onChange={this.selectedCustomerChange} />
              <Order customer={this.state.selectedCustomer} onChange={this.orderChange} />
              <Button className="green" onClick={this.placeOrder}>Order Plaatsen</Button>
            </div>

          )
        }


      </Container>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js